import React from 'react';
import clsx from 'clsx';
import styles from './StepProgress.scss';
function DefaultStep(_ref) {
  let {
    isActive
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.defaultStep, isActive && styles.defaultStepActive),
    "aria-hidden": "true"
  });
}
export function StepProgress(_ref2) {
  let {
    currentStep,
    totalSteps,
    className,
    renderStep
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.root, className),
    role: "progressbar",
    "aria-valuenow": currentStep,
    "aria-valuemin": 0,
    "aria-valuemax": totalSteps
  }, Array.from({
    length: totalSteps
  }, (_, i) => {
    const isActive = i <= currentStep;
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: clsx(styles.step, isActive && styles.stepActive)
    }, renderStep ? renderStep(i, isActive) : /*#__PURE__*/React.createElement(DefaultStep, {
      isActive: isActive
    }));
  }));
}
//# sourceMappingURL=StepProgress.js.map